import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { createPayment, getPayment } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializePaymentForm } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import { selectPaymentModel } from 'selectors/entitySelector';
import { paymentEditCrumb, paymentAddCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Grid from 'screens/components/basic/Grid';


class PaymentSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: null
        };
    }

    // control if is ADD or EDIT
    componentWillMount() {
        const paymentId = this.props.params ? this.props.params.id : 0;
        //if true dispatch an action to retrive data from API and set Status to EDIT
        if (paymentId) {
            this.setState({ status: "EDIT" });
            this.props.getPayment(paymentId, this.props.branchId);
        }
        //if false dispatch an action to clean the form and set default values and set Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
    }

    // is SUCCEEDED or FAILED
    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }
    }

    //when data is saved successfully
    saveSuccess = () => {
        this.redirectToListPayment();
        this.props.showSuccess(this.state.status === "EDIT" ? LOOKUP.payment.messages.editedMessage : LOOKUP.payment.messages.createdMessage);
    }

    //when data is not saved, failure
    saveFailure = () => {
        this.props.showError(LOOKUP.payment.messages.saveErrorMessage);
    }

    savePayment = () => {
        const payment = this.props.paymentModel;
        this.props.createPayment(payment);
    }

    redirectToListPayment = () => {
        this.props.navigate("/manage/payment");
    }

    render() {
        const p = this.props;
        const title = this.state.status === 'EDIT' ? "Edit Payment" : "Add New Payment";
        const breadCrumbPage = this.state.status === 'EDIT' ? paymentEditCrumb : paymentAddCrumb;

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.manage.items.payment.link}>{LOOKUP.menu.manage.items.payment.text}</Link></li>
                    <li className="active">Manage Payment</li>
                </ol>
                <h2>Manage Payment <Button type="HeaderBackPage" onTouchTap={() => this.redirectToListPayment()} /></h2>
            </div>);

        return (
            <Grid headerContent={breadCrumbPage}>
                <PageHeader className="row m-0 pa-2" title={title} />
                <CardSimple className="paddingForMobileDevices">
                    <div className="form-group">
                        <div className="row">
                            <div className="col-lg-8">
                                {
                                    this.state.status === "EDIT" ? (
                                        <TextInput name={p.name + "Id"}
                                            label={LOOKUP.payment.id.label}
                                            floatingLabelText={LOOKUP.payment.id.label}
                                            hintText={LOOKUP.payment.id.hintText}
                                            disabled={true}
                                            fullWidth={true} />
                                    ) : null
                                }
                            </div>
                            <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                <br />
                                <ToggleInput className="payment_status btnToggleLabel" name={`${p.name}Status`} label={LOOKUP.payment.status.label} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <SelectInput name={`${p.name}Name`}
                                    label={LOOKUP.payment.name.label}
                                    floatingLabelText={LOOKUP.payment.name.label}
                                    hintText={LOOKUP.payment.name.label}
                                    options={LOOKUP.payment.paymentOptions}
                                    fullWidth={true} />
                            </div>
                        </div>
                    </div>
                </CardSimple>
                <PageBottomWithButtons>
                    <Button
                        name="saveButton"
                        className="pull-right btnNewBrandPOS"
                        label={LOOKUP.payment.controls.saveButton}
                        primary={true}
                        onTouchTap={() => this.savePayment()} />
                    <Button
                        type="CancelButton"
                        name="buttonCancel"
                        className="pull-right btn-space btnCancelOperation"
                        label={LOOKUP.common.cancel.text}
                        onTouchTap={() => this.redirectToListPayment()} />
                </PageBottomWithButtons>
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        paymentModel: selectPaymentModel(state, props.name),
        saveSuccess: state.form[props.name + "SaveSuccess"],
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        init: (name) => dispatch(initializePaymentForm(name)),
        createPayment: (payment) => dispatch(createPayment(payment, props.name)),
        getPayment: (paymentId, branchId) => dispatch(getPayment(paymentId, branchId, props.name)),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(PaymentSave));